import { Divider } from '@chakra-ui/react';
import classes from './InspectionReqCard.module.scss';

const InspectionReqCard = ({content, onClick}) => {

    return (
        <div 
            className={classes.InspectionReqCard} 
            onClick={onClick}
            role="button"
            tabIndex="0"
            aria-label={`View details for ${content.name}`}
            style={{ cursor: 'pointer' }}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    onClick();
                }
            }}
        >
            <div className={classes.ProcessingDiv}>
                <p className={classes.status + ' ' + classes[content.status.toLowerCase()]}>
                    ● {content.status}
                </p>
            </div>

            <h3>{content.name}</h3>

            <div className={classes.Info}>
                <div className={classes.InfoContext}>
                    <div className={classes.InfoIconContainer}>
                    <i className="fas fa-gavel"></i>
                    </div>
                    <p>{content.auction}</p>
                </div>
                <div className={classes.InfoContext}>
                    <div className={classes.InfoIconContainer}>
                    <i className="fas fa-tag"></i>
                    </div>
                    <p>Bid No: {content.bidNo.replace(/^No\./, '')}</p>
                </div>
                <div className={classes.InfoContext}>
                    <div className={classes.InfoIconContainer}>
                    <i className="far fa-calendar"></i>
                    </div>
                    <p>{content.date}</p>
                </div>
            </div>
            <Divider orientation='horizontal' />
        </div>
    )
}

export default InspectionReqCard;